import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { PaymentLogos } from "@/components/shop/PaymentLogos";

export default function PayseraPay({ buildOrder, onPaid }) {
  const { t, lang } = useLang();
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/config").then((r) => setCfg(r.data)); }, []);
  if (!cfg) return <Loader2 className="w-5 h-5 animate-spin text-orange-500" />;
  const demo = cfg.payment_mode === "demo";

  const pay = async () => {
    setBusy(true);
    try {
      const o = await buildOrder();
      const { data } = await api.post(`/orders/${o.id}/pay`, { lang });
      if (data.payment_url) return window.location.assign(data.payment_url);
      onPaid((await api.post(`/orders/${o.id}/capture`)).data);
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  return (
    <div className="space-y-3">
      <button data-testid="paysera-pay-btn" onClick={pay} disabled={busy}
        className="w-full h-12 bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest hover:bg-orange-400 disabled:opacity-60 inline-flex items-center justify-center gap-2 transition-colors">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} {demo ? t("pay_demo") : t("pay_paysera")}
      </button>
      <PaymentLogos />
      <p className="text-xs text-slate-400">{t("paysera_note")}</p>
      {demo && <p data-testid="paysera-demo-note" className="text-xs text-amber-400 font-mono-x">{t("demo_note")}</p>}
      {cfg.payment_mode === "test" && <p data-testid="paysera-test-note" className="text-xs text-amber-400 font-mono-x">{t("test_note")}</p>}
    </div>
  );
}
